"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _encryption = _interopRequireDefault(require("../encryption"));
var _helpers = _interopRequireDefault(require("../helpers"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var fiscal = exports["default"] = /*#__PURE__*/function (_Core) {
  function fiscal(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, fiscal);
    _this = _callSuper(this, fiscal, [props]);
    _this.connection = props.connection;
    _this.on = _this.on.bind(_this);
    _this.appName = props.appName;
    _this._events = {};
    _this.init();
    _this.services = props.services;
    _this.publicKey = props.publicKey;
    _this.cryptoKey = props.cryptoKey;
    _this.ready = false;
    _this.myServices = ["lfr"];
    _this.checkReadyRetryCount = 0;
    _this.maxCheckReadyRetries = 20;
    _this.checkReadyRetryDelay = 3000;
    return _this;
  }

  // Helper method to generate consistent timestamps
  (0, _inherits2["default"])(fiscal, _Core);
  return (0, _createClass2["default"])(fiscal, [{
    key: "generateTimestamp",
    value: function generateTimestamp() {
      return Number(BigInt(Date.now()) * 1000000n);
    }

    // Helper method to convert base64 to ArrayBuffer
  }, {
    key: "base64ToArrayBuffer",
    value: function base64ToArrayBuffer(base64) {
      return _helpers["default"].base64ToArrayBuffer(base64);
    }
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      return Object.keys(this.services).some(function (key) {
        return _this2.myServices.includes(key);
      });
    }
  }, {
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var payload, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              payload = {
                action: "System.Wfs.CheckReady",
                uuid: (0, _uuid.v4)(),
                origin: "sdk-" + this.appName,
                request_uuid: "",
                timestamp: this.generateTimestamp(),
                data: "{}"
              };
              _context.next = 1;
              return this.connection.invoke("messaging", payload);
            case 1:
              _logger["default"].info("Check Ready", "Checking if everything is ready", "Fiscal");
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error("Error in getCheckReady:", _t);
              throw _t;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }() // Helper method to clear stale keys after restart
  }, {
    key: "clearStaleKeys",
    value: function clearStaleKeys() {
      var _this3 = this;
      Object.keys(this.services).forEach(function (serviceName) {
        var _this3$services$servi;
        if (_this3.myServices.includes(serviceName) && (_this3$services$servi = _this3.services[serviceName]) !== null && _this3$services$servi !== void 0 && _this3$services$servi.symmetricKey) {
          // Clear the old symmetric key to force re-exchange
          delete _this3.services[serviceName].symmetricKey;
          _logger["default"].info("KeyCleanup", "Cleared stale symmetric key for ".concat(serviceName), "Fiscal");
        }
      });
    }
  }, {
    key: "maybeFinishInitialization",
    value: function maybeFinishInitialization() {
      var _this4 = this;
      // Check if we have a service with symmetric key
      var hasServiceWithSymmetricKey = Object.keys(this.services).some(function (serviceName) {
        var _this4$services$servi;
        return _this4.myServices.includes(serviceName) && ((_this4$services$servi = _this4.services[serviceName]) === null || _this4$services$servi === void 0 ? void 0 : _this4$services$servi.symmetricKey);
      });
      if (!this.ready && hasServiceWithSymmetricKey) {
        this.ready = true;
        this.trigger("ready", true);
        _logger["default"].success("Initialization", "Module is now fully ready", "Fiscal");
      }
    }

    // Helper method to check if service is ready for encrypted communication
  }, {
    key: "isServiceReady",
    value: function isServiceReady() {
      var serviceName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "lfr";
      var service = this.services[serviceName];
      if (!service) {
        throw new Error("Service ".concat(serviceName, " not found. Make sure the service is running and detected."));
      }
      if (!service.symmetricKey) {
        throw new Error("Service ".concat(serviceName, " is not ready. Symmetric key exchange not completed yet."));
      }
      return service;
    }

    // Svaka metoda sada direktno poziva 'waitForResponse'
  }, {
    key: "printTicket",
    value: function () {
      var _printTicket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(code) {
        var service, command, uuid, origin, timestamp, payload, response, _t2;
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              service = this.isServiceReady("lfr");
              command = "System.Wfs.PrintTicket";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context2.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(service, {
                command: command,
                params: code
              }, uuid, origin, timestamp);
            case 1:
              payload = _context2.sent;
              _context2.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context2.next = 3;
              return this.waitForResponse(uuid, service);
            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", response);
            case 4:
              _context2.prev = 4;
              _t2 = _context2["catch"](0);
              _logger["default"].error("PrintTicket", _t2.message, "Fiscal");
              throw _t2;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 4]]);
      }));
      function printTicket(_x) {
        return _printTicket.apply(this, arguments);
      }
      return printTicket;
    }()
  }, {
    key: "cancelTicket",
    value: function () {
      var _cancelTicket = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(code) {
        var service, command, uuid, origin, timestamp, payload, _t3;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              service = this.isServiceReady("lfr");
              command = "System.Wfs.CancelTicket";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context3.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(service, {
                command: command,
                params: code
              }, uuid, origin, timestamp);
            case 1:
              payload = _context3.sent;
              _context3.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context3.next = 3;
              return this.waitForResponse(uuid, service);
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
              _context3.prev = 4;
              _t3 = _context3["catch"](0);
              _logger["default"].error("CancelTicket", _t3.message, "Fiscal");
              throw _t3;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 4]]);
      }));
      function cancelTicket(_x2) {
        return _cancelTicket.apply(this, arguments);
      }
      return cancelTicket;
    }()
  }, {
    key: "getConfigurableOptions",
    value: function () {
      var _getConfigurableOptions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var service, command, uuid, origin, timestamp, payload, _t4;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              service = this.isServiceReady("lfr");
              command = "System.Wfs.GetConfigurableOptions";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context4.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(service, {
                command: command,
                params: {}
              }, uuid, origin, timestamp);
            case 1:
              payload = _context4.sent;
              _context4.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context4.next = 3;
              return this.waitForResponse(uuid, service);
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
              _context4.prev = 4;
              _t4 = _context4["catch"](0);
              _logger["default"].error("GetConfigurableOptions", _t4.message, "Fiscal");
              throw _t4;
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 4]]);
      }));
      function getConfigurableOptions() {
        return _getConfigurableOptions.apply(this, arguments);
      }
      return getConfigurableOptions;
    }()
  }, {
    key: "setConfigurableOptions",
    value: function () {
      var _setConfigurableOptions = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(options) {
        var service, command, uuid, origin, timestamp, payload, _t5;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              service = this.isServiceReady("lfr");
              command = "System.Wfs.SetConfigurableOptions";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context5.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(service, {
                command: command,
                params: {
                  data: options
                }
              }, uuid, origin, timestamp);
            case 1:
              payload = _context5.sent;
              _context5.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context5.next = 3;
              return this.waitForResponse(uuid, service);
            case 3:
              return _context5.abrupt("return", _context5.sent);
            case 4:
              _context5.prev = 4;
              _t5 = _context5["catch"](0);
              _logger["default"].error("SetConfigurableOptions", _t5.message, "Fiscal");
              throw _t5;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 4]]);
      }));
      function setConfigurableOptions(_x3) {
        return _setConfigurableOptions.apply(this, arguments);
      }
      return setConfigurableOptions;
    }()
  }, {
    key: "xReport",
    value: function () {
      var _xReport = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var service, command, uuid, origin, timestamp, payload, _t6;
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              service = this.isServiceReady("lfr");
              command = "System.Wfs.XReport";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context6.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(service, {
                command: command,
                params: {}
              }, uuid, origin, timestamp);
            case 1:
              payload = _context6.sent;
              _context6.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context6.next = 3;
              return this.waitForResponse(uuid, service);
            case 3:
              return _context6.abrupt("return", _context6.sent);
            case 4:
              _context6.prev = 4;
              _t6 = _context6["catch"](0);
              _logger["default"].error("XReport", _t6.message, "Fiscal");
              throw _t6;
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 4]]);
      }));
      function xReport() {
        return _xReport.apply(this, arguments);
      }
      return xReport;
    }()
  }, {
    key: "zReport",
    value: function () {
      var _zReport = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var service, command, uuid, origin, timestamp, payload, _t7;
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              service = this.isServiceReady("lfr");
              command = "System.Wfs.ZReport";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context7.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(service, {
                command: command,
                params: {}
              }, uuid, origin, timestamp);
            case 1:
              payload = _context7.sent;
              _context7.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context7.next = 3;
              return this.waitForResponse(uuid, service);
            case 3:
              return _context7.abrupt("return", _context7.sent);
            case 4:
              _context7.prev = 4;
              _t7 = _context7["catch"](0);
              _logger["default"].error("ZReport", _t7.message, "Fiscal");
              throw _t7;
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 4]]);
      }));
      function zReport() {
        return _zReport.apply(this, arguments);
      }
      return zReport;
    }()
  }, {
    key: "transferMoney",
    value: function () {
      var _transferMoney = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(amount, action) {
        var service, command, uuid, origin, timestamp, payload, _t8;
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              service = this.isServiceReady("lfr");
              command = "System.Wfs.TransferMoney";
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = this.generateTimestamp();
              _context8.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(service, {
                command: command,
                params: {
                  "Money": [{
                    amount: amount,
                    action: action
                  }]
                }
              }, uuid, origin, timestamp);
            case 1:
              payload = _context8.sent;
              _context8.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              _context8.next = 3;
              return this.waitForResponse(uuid, service);
            case 3:
              return _context8.abrupt("return", _context8.sent);
            case 4:
              _context8.prev = 4;
              _t8 = _context8["catch"](0);
              _logger["default"].error("TransferMoney", _t8.message, "Fiscal");
              throw _t8;
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 4]]);
      }));
      function transferMoney(_x4, _x5) {
        return _transferMoney.apply(this, arguments);
      }
      return transferMoney;
    }() // 'waitForResponse' sada prima samo 'uuid' i 'service'
  }, {
    key: "waitForResponse",
    value: function () {
      var _waitForResponse = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0(uuid, service) {
        var _this5 = this;
        return _regenerator["default"].wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              return _context0.abrupt("return", new Promise(function (resolve, reject) {
                var timeout = setTimeout(function () {
                  reject(new Error("Response timeout for UUID: ".concat(uuid)));
                }, 30000); // 30 second timeout

                _this5.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(msg) {
                    var isResponseMatch, decryptedData, jsonObject, _t9;
                    return _regenerator["default"].wrap(function (_context9) {
                      while (1) switch (_context9.prev = _context9.next) {
                        case 0:
                          // Check if this is a response to our fiscal request
                          // The fiscal service might respond with System.Wfs.ServiceCall where the uuid field contains our request UUID
                          isResponseMatch = msg.action === "System.SDK.ServiceCall" && msg.requestUuid === uuid || msg.action === "System.Wfs.ServiceCall" && msg.uuid === uuid || msg.action === "System.Wfs.ServiceCall" && msg.requestUuid === uuid;
                          if (!isResponseMatch) {
                            _context9.next = 4;
                            break;
                          }
                          clearTimeout(timeout);
                          _context9.prev = 1;
                          _context9.next = 2;
                          return _encryption["default"].decryptSymmetrically(service, msg.data);
                        case 2:
                          decryptedData = _context9.sent;
                          jsonObject = JSON.parse(decryptedData); // Only return data if this is a proper response command (ends with .Response)
                          if (jsonObject.command && jsonObject.command.endsWith('.Response')) {
                            clearTimeout(timeout);
                            resolve(jsonObject.params || jsonObject);
                          } else {
                            // Don't reject here - just ignore echoed data and keep waiting for the real response
                          }
                          _context9.next = 4;
                          break;
                        case 3:
                          _context9.prev = 3;
                          _t9 = _context9["catch"](1);
                          reject(new Error("Failed to decrypt fiscal response: " + _t9.message));
                        case 4:
                        case "end":
                          return _context9.stop();
                      }
                    }, _callee9, null, [[1, 3]]);
                  }));
                  return function (_x8) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));
            case 1:
            case "end":
              return _context0.stop();
          }
        }, _callee0);
      }));
      function waitForResponse(_x6, _x7) {
        return _waitForResponse.apply(this, arguments);
      }
      return waitForResponse;
    }()
  }, {
    key: "retryCheckReady",
    value: function () {
      var _retryCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1() {
        var _this6 = this;
        return _regenerator["default"].wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              if (this.checkReadyRetryCount < this.maxCheckReadyRetries) {
                this.checkReadyRetryCount++;
                setTimeout(function () {
                  _this6.getCheckReady();
                }, this.checkReadyRetryDelay);
              } else {
                _logger["default"].error("Retry Failed", "Lfr not ready after maximum retries", "Fiscal");
                this.trigger("ready", false);
              }
            case 1:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this);
      }));
      function retryCheckReady() {
        return _retryCheckReady.apply(this, arguments);
      }
      return retryCheckReady;
    }() // Override handleMessage to handle symmetric key exchange failures
  }, {
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(message) {
        var _this$services$messag,
          _this7 = this;
        var _JSON$parse, ready, _t0;
        return _regenerator["default"].wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(message.origin === "sdk-" + this.appName && message.action !== "System.Wfs.ServiceCall")) {
                _context10.next = 1;
                break;
              }
              return _context10.abrupt("return");
            case 1:
              _t0 = message.action;
              _context10.next = _t0 === "System.SDK.ServiceNotification.Response" ? 2 : _t0 === "System.Wfs.Notify.Ready" ? 4 : _t0 === "System.SDK.ServiceCall" ? 5 : _t0 === "System.Wfs.ServiceCall" ? 5 : 6;
              break;
            case 2:
              if (this.myServices.includes(message.origin)) {
                _context10.next = 3;
                break;
              }
              return _context10.abrupt("return");
            case 3:
              // Clear any existing stale key before processing new service
              if ((_this$services$messag = this.services[message.origin]) !== null && _this$services$messag !== void 0 && _this$services$messag.symmetricKey) {
                delete this.services[message.origin].symmetricKey;
                _logger["default"].info("ServiceNotification", "Cleared stale symmetric key for ".concat(message.origin), "Fiscal");
              }
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New fiscal service added", message.origin);

              // Let the core module handle symmetric key exchange
              // Just check if we should mark as ready after a delay
              setTimeout(function () {
                _this7.maybeFinishInitialization();
              }, 1000);
              return _context10.abrupt("return");
            case 4:
              _JSON$parse = JSON.parse(message.data), ready = _JSON$parse.ready;
              if (ready) {
                this.checkReadyRetryCount = 0;
                // Clear stale keys when service becomes ready
                this.clearStaleKeys();
                this.maybeFinishInitialization();
              } else {
                this.retryCheckReady();
              }
              return _context10.abrupt("return");
            case 5:
              return _context10.abrupt("continue", 7);
            case 6:
              return _context10.abrupt("continue", 7);
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function handleMessage(_x9) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "init",
    value: function init() {
      var _this8 = this;
      _logger["default"].info("Initialization", "fiscal module initializing", "fiscal");
      if (!this.detectServices()) {
        _logger["default"].warn("Initialization", "No fiscal services found yet.", "fiscal");
      } else {
        _logger["default"].success("Initialization done", "Module is now ready", "fiscal");
      }
      this.getCheckReady();
      this.connection.on("messaging", this.handleMessage.bind(this));

      // Set a timeout to mark as ready, similar to pocket module
      setTimeout(function () {
        _this8.maybeFinishInitialization();
      }, 3000);
    }
  }]);
}(_core["default"]);